import { useRouter, useRoute } from 'vue-router'
import type { AisRouteState } from '~/types/instantsearch'

export const attributesForProductTile = ['sku', 'itemId', 'slug', 'name', 'yotpo', 'stock', 'finalPrice', 'labels', 'swatch', 'defaultImage', 'defaultVariationImage', 'price', 'images', 'erpinfo', 'variationPrices', 'labelTags', 'vatRate', 'customLabel']
export const attributesForProductTileMini = ['slug', 'name', 'stock', 'finalPrice', 'defaultImage', 'defaultVariationImage', 'price', 'erpinfo', 'variationPrices', 'customLabel']

/**
 * Filter for products listed by number in relatedProducts, synonymProducts and buyAlsoProducts. The numbers are
 * itemIds: Algolia's numeric "id" is "itemId" in Typesense, whose own id is "<sku>-<itemId>" (16.10.2026)
 */
export const productItemIdFilter = (ids: (number | string | null | undefined)[]): string =>
  ids.filter(id => id !== null && id !== undefined && id !== '').map(id => `itemId:${id}`).join(' OR ')

export const nuxtRouter = () => {
  const router = useRouter()
  const route = useRoute()

  return {
    read(): any {
      return route.query
    },
    write(routeState: AisRouteState) {
      if (this.createURL(routeState) === this.createURL(this.read())) {
        return
      }
      router.push({ query: routeState })
    },
    createURL(routeState: AisRouteState) {
      return router.resolve({ query: routeState }).href
    },
    onUpdate() {},
    dispose() {}
  }
}
